/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
import { Box, Skeleton, Table, TableBody, TableContainer, TableHead } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { PAGE_SIZE } from 'services/constants/env';
import { ItemWithId } from 'services/constants/types';
import { EasTableHeader } from './EasTableHeader';
import { EasRow } from './EasRow';
import { ECheckedAll, TEasTableProps } from './types';

const ROWS = Array.from(new Array(PAGE_SIZE / 2));

export const EasTable = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows = ROWS,
	highlightedRow,
	name,
	showButtons,
	checkedIds,
	setCheckedIds,
	CustomComponent,
}: TEasTableProps<T>) => {
	const [selectedRow, setSelectedRow] = useState<number | null>(null);
	const [checkedAll, setCheckedAll] = useState<ECheckedAll>(ECheckedAll.NO_ONE);

	const handleCheckAll = (checked: ECheckedAll) => {
		if (checked === ECheckedAll.ALL) {
			setCheckedIds(items?.map((item) => item.id) || []);
			setCheckedAll(ECheckedAll.ALL);
		} else if (checked === ECheckedAll.NO_ONE) {
			setCheckedIds([]);
			setCheckedAll(ECheckedAll.NO_ONE);
		} else if (checked === ECheckedAll.SOME) {
			setCheckedAll(ECheckedAll.SOME);
		}
	};

	const handleCheckId = (id: number, checked: boolean) => {
		if (checked) {
			setCheckedIds([...checkedIds, id]);
		} else {
			setCheckedIds(checkedIds.filter((checkedId) => checkedId !== id));
		}
		// setCheckedAll(
		// 	checkedIds.length === items?.length
		// 		? ECheckedAll.ALL
		// 		: checkedIds.length > 0
		// 			? ECheckedAll.SOME
		// 			: ECheckedAll.NO_ONE,
		// );
	};

	useEffect(() => {
		if (checkedIds.length === items?.length) {
			setCheckedAll(ECheckedAll.ALL);
		} else if (checkedIds.length > 0) {
			setCheckedAll(ECheckedAll.SOME);
		} else {
			setCheckedAll(ECheckedAll.NO_ONE);
		}
	}, [checkedIds, items]);

	const [firstRender, setFirstRender] = useState(true);

	useEffect(() => {
		if (firstRender) {
			setFirstRender(false);
		}
	}, [firstRender]);

	return (
		<Box>
			<TableContainer>
				<Table onMouseLeave={() => setSelectedRow(null)} onBlur={() => setSelectedRow(null)}>
					<TableHead>
						<EasTableHeader
							tableStructure={tableStructure}
							checkedAll={checkedAll}
							setCheckAll={handleCheckAll}
						/>
					</TableHead>
					{!!items?.length && (
						<TableBody
							onMouseLeave={() => setSelectedRow(null)}
							onBlur={() => setSelectedRow(null)}
						>
							{!!items &&
								items?.map((item, index) => (
									<EasRow<T>
										key={item.id}
										item={item}
										setSelectedRow={setSelectedRow}
										selectedRow={selectedRow}
										highlightedRow={highlightedRow}
										index={index}
										tableStructure={tableStructure}
										handleAction={handleAction}
										handleLink={handleLink}
										showButtons={showButtons?.[index]}
										checkedRow={checkedIds.includes(item.id)}
										setCheckRow={(checked) => handleCheckId(item.id, checked)}
										CustomComponent={CustomComponent}
									/>
								))}
						</TableBody>
					)}
				</Table>
				{itemsIsLoading && !items?.length && (
					<Box
						sx={{
							pb: '1px',
						}}
					>
						{skeletonRows?.map(() => (
							<Skeleton
								key={nanoid()}
								variant="rectangular"
								height="33px"
								sx={{
									mb: '33px',
								}}
							/>
						))}
					</Box>
				)}
				{!itemsIsLoading && !items?.length && (
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: skeletonRows.length * 33 + 33,
							width: '100%',
							color: '#016196',
							fontSize: '24px',
							fontWeight: 'bold',
						}}
					>
						No {name ? `${name}s` : 'items'} found...
					</Box>
				)}
			</TableContainer>
		</Box>
	);
};
